const authManager = {
  setAccessToken: (accessToken) => {
    try {
      localStorage.setItem("accessToken", accessToken);
    } catch (error) {
      console.error("Error setting access token:", error);
    }
  },

  getAccessToken: () => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("accessToken");
  },

  deleteAccessToken: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("accessToken");
    }
  },

  hasAccessToken: () => {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("accessToken");
  },

};

export default authManager;
